export const basicHome = {
  security: "security",
  guest_ssid: "gssid_word",
  guest_pwd: "gpwd_word",
  armor_stat: "armor_stat",
};

export default basicHome;
